import { z } from 'zod';
import { grammarPointSchema } from '../grammar-point-schema';

const grammarPointSummarySchemaDefinition = grammarPointSchema
  .pick({
    slug: true,
    level: true,
    subBand: true,
    family: true,
    sortOrder: true,
    title: true,
    formula: true,
    jobLine: true,
  })
  .extend({ id: z.number().int() });

export const grammarPointSummarySchema: typeof grammarPointSummarySchemaDefinition =
  grammarPointSummarySchemaDefinition;

export type IGrammarPointSummary = z.infer<typeof grammarPointSummarySchema>;
